import React from 'react';
import SVGIcon from '../components/SVGIcon';
import checkIcon from '../icons/non-prefilled/16x16/check.svg';
import * as styles from './PricingCheckIcon.module.scss';

const PricingCheckIcon = () => {
  return <SVGIcon className={styles.checkIcon}>{checkIcon}</SVGIcon>;
};

export default PricingCheckIcon;
